import { orderApiSpace } from 'feature/productOrder/namespaces/orderApiSpace'
import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { useUploadImageMutation } from 'feature/productOrder/redux/orders.api'
import { FC, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useAppSelector, useActions } from 'store/hooks'
import { DragDropInput } from 'widget/DragDropFile/dragDropInput/DragDropInput'

interface IInputImages {
  data: orderApiSpace.ProductParamData
  productId: number
}

export const InputImages: FC<IInputImages> = ({ data, productId }) => {
  const { control } = useForm()
  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const images: orderFormSpace.Images[] = useAppSelector(
    state => state.orderForm.forms[currentEditForm].images,
  )
  const [fileList, setFileList] = useState<orderFormSpace.Images[]>(
    images.filter(cur => cur.paramId === data.id && cur.serverUid !== null),
  )

  const { setParamImagesOrder, removeParamImagesOrder } = useActions()
  const [uploadImage] = useUploadImageMutation()

  useEffect(() => {
    if (fileList.length > 0) {
      setParamImagesOrder(
        fileList.map(item => ({
          ...item,
          productId: productId,
          paramId: data.id,
        })),
      )
    } else {
      removeParamImagesOrder(data.id)
    }
  }, [fileList])

  const loadFile = async (file: File) => {
    const ImgData = await uploadImage(file).unwrap()
    return ImgData
  }

  return (
    <Controller
      control={control}
      name={`${data.id}_${data.name}`}
      render={() => (
        <DragDropInput
          limit={5}
          errorText='1 файл не загружен - превышен лимит'
          loadFileToApi={loadFile}
          helperTitle='Загрузите файл'
          allowedFormats='image/png, image/jpeg, image/jpg'
          fileList={fileList}
          setFileList={setFileList}
          isError={false}
          labelName={data.name}
        />
      )}
    />
  )
}
